import React, { useContext } from 'react'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { DatePicker } from '@progress/kendo-react-dateinputs'
import { AuthSessionContext } from 'utils/AuthContext'
import { defaultDateFormat, formatDateStripTime } from 'utils/date'

interface DateFilterProps {
  placeholder?: string
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
  isDateOnly?: boolean
}

export const DateFilter: React.FC<DateFilterProps> = ({
  placeholder,
  filter,
  onFilterChange,
  isDateOnly,
  ...props
}) => {
  const [auth] = useContext(AuthSessionContext)
  const selectValue = filter.value
    ? filter.value instanceof Date
      ? filter.value
      : new Date(filter.value)
    : null
  const dateFormatType = getDateFormatType(
    auth?.user.dateFormatType.name,
    defaultDateFormat,
    isDateOnly
  )
  return (
    <DatePicker
      {...props}
      placeholder={placeholder}
      value={selectValue}
      onChange={(event) => {
        if (event.value) {
          const fixedDate = new Date(
            event.value.getFullYear(),
            event.value.getMonth(),
            event.value.getDate()
          )
          onFilterChange.call(undefined, {
            nextFilter: { ...filter, value: fixedDate.toDateString() },
          })
        }
      }}
      format={dateFormatType}
    />
  )
}

const getDateFormatType = (
  userDateFormat: string | undefined,
  defaultDateFormat: string,
  isDateOnly?: boolean
): string => {
  const dateFormat = userDateFormat || defaultDateFormat
  return isDateOnly ? formatDateStripTime(dateFormat) : dateFormat
}
